import { ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'

interface LayoutProps {
    children: ReactNode  // whatever page is being wrapped gets passed in here
}

export default function Layout({ children }: LayoutProps) {
    const location = useLocation()

    const navLinks = [
        { path: '/',              label: 'Home' },
    ]

    return (
        <div className="min-h-screen flex flex-col bg-white">

            {/* ── Navbar ───────────────────────────────────────────── */}
            <header className="border-b border-gray-100 px-6 py-4">
                <div className="max-w-4xl mx-auto flex items-center justify-between">

                    {/* Logo / brand */}
                    <Link to="/" className="font-bold text-lg tracking-tight text-gray-900">
                        youreindebt
                    </Link>

                    {/* Nav links */}
                    <nav className="flex gap-6">
                        {navLinks.map(link => (
                            <Link
                                key={link.path}
                                to={link.path}
                                className={`text-sm transition-colors ${
                                    location.pathname === link.path
                                        ? 'text-blue-600 font-medium'
                                        : 'text-gray-500 hover:text-gray-900'
                                }`}
                            >
                                {link.label}
                            </Link>
                        ))}
                    </nav>

                </div>
            </header>

            {/* ── Page content ─────────────────────────────────────── */}
            {/* This is where HomePage, ScholarshipsPage, etc. render */}
            <main className="flex-1">
                {children}
            </main>

            {/* ── Footer ───────────────────────────────────────────── */}
            <footer className="border-t border-gray-100 px-6 py-8 mt-auto">
                <div className="max-w-4xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
                    <p className="text-sm text-gray-400">
                        Built at a hackathon to fight the OSAP cuts.
                    </p>
                </div>

            </footer>

        </div>
    )
}